export const defaultOptions = {
  portalId: '5041527',
  formId: '5ca67de8-0c15-4dec-8671-863f1c87cefc',
  sfdcCampaignId: '701f40000013BH4AAM',
  target: 'integration-hubspot',
};

export const carrierOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '958785f2-d686-41c3-a970-e620e339b5bf',
  sfdcCampaignId: '7015G000001qQIcQAM',
};

export const carrierPageOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: 'f8c53fec-5426-4d12-a6e2-79375099884d',
  sfdcCampaignId: '7015G000001qQIcQAM',
};

export const enterpriseShippingOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: 'c47069a6-2c7b-4c2e-b28d-6126e58f1e2a',
  sfdcCampaignId: '7015G000000Tc0AQA',
};

export const dataInsightsOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '01799528-ca38-4dab-9a23-ff9ed0eeab94',
  sfdcCampaignId: '7015G000000TdJhQAK',
};

export const tmsIntegrationOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '34003116-8389-4ded-8b6b-cd8dcd4fcc47',
  sfdcCampaignId: '7015G000000TdsXQAS',
};

export const modeOptimizationOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '6e402403-fb02-48c0-8e21-71b6e9fada5c',
  sfdcCampaignId: '7015G000000TcSsQAK',
};

export const smbShippingOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '78d15ec2-d40a-44d5-a611-21bb03e57240',
  sfdcCampaignId: '7015G000000TdViQAK',
};

export const multimodalOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '61f6ea13-b0ec-466f-b1b9-7bb515fa23b6',
  sfdcCampaignId: '7015G000001qSxCQAU',
};

export const shipperGuideOptions = {
  region: 'na1',
  portalId: '5041527',
  formId: '8249220c-3449-405f-b7b8-96d458e08662',
  sfdcCampaignId: '',
};

export const setHubspotFormIntegration = (options) => {
  const script = document.createElement('script');

  script.src = 'https://js.hsforms.net/forms/v2.js';
  script.onload = () => {
    if (window.hbspt) {
      window.hbspt.forms.create(options);
    }
  };

  document.body.appendChild(script);
};
